// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__tDDzY","outline":"button_outline__2Bti_"};